module.exports = __webpack_public_path__ + "img/microplastics-inspect-portrait.9d1be12f.png";